import { render } from "./AttributeOptionsEditor.vue?vue&type=template&id=426bd4d6&scoped=true"
import script from "./AttributeOptionsEditor.vue?vue&type=script&lang=js"
export * from "./AttributeOptionsEditor.vue?vue&type=script&lang=js"

import "./AttributeOptionsEditor.vue?vue&type=style&index=0&id=426bd4d6&scoped=true&lang=css"

import exportComponent from "/var/www/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-426bd4d6"]])

export default __exports__